import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarRail,
  useSidebar,
} from "@/components/shadcn/sidebar";

import { For, Show } from "solid-js";
import { NavUser } from "./sidebar/nav-user";
import { SidebarItem } from "./sidebar/nav-item";
import { Brand } from "./sidebar/brand";

export const AppSidebar = (props) => {

  const { isMobile } = useSidebar();

  const menuItems = [
    {
      title: "Home",
      url: "/home",
      icon: 'fa6-solid:house',
      show: true,
    },
    {
      title: "Checkup",
      url: "/checkup",
      icon: 'maki:doctor',
      show: true,
    },
    {
      title: "Appointments",
      url: "/appointments",
      icon: 'fa6-solid:calendar-days',
      show: true,
    },
    {
      title: "Payments",
      url: "/payments",
      icon: 'fa6-solid:cash-register',
      show: true,
    },
    {
      title: "Therapies",
      url: "/therapies",
      icon: 'healthicons:occupational-therapy',
      show: true,
    },
    {
      title: "Patients",
      url: "/patients",
      icon: 'fluent:patient-20-filled',
      show: true,
    },
    {
      title: "History",
      url: "/history",
      icon: 'bxs:user-account',
      show: true,
    },
    {
      title: "Diagnoses",
      url: "/diagnoses",
      icon: 'fa6-solid:boxes-stacked',
      show: true,
    },
    {
      title: "Complaints",
      url: "/complaints",
      icon: 'fa6-solid:comment',
      show: true,
    },
    {
      title: "Tests",
      url: "/tests",
      icon: 'fa6-solid:vial',
      show: true,
    },
    {
      title: "Questions",
      url: "/questions",
      icon: 'fa6-solid:question',
      show: true,
    },
  ];

  return (
    <Sidebar variant="sidebar" collapsible="icon" side="left" class="bg-white dark:bg-black">
      <SidebarHeader>
        <Show when={!isMobile()}>
          <Brand />
        </Show>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              <For each={menuItems}>{(item) =>
                <Show when={item.show}>
                 <SidebarItem item={item} />
                </Show>
              }</For>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={props.user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
